const pad = (n) => String(n).padStart(2, '0');

export const toLocalDatetime = (iso) => {
  if (!iso) return '';
  const d = new Date(iso);
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
};

export const splitDatetime = (value) => {
  if (!value) return { date: '', time: '' };
  const [date, timePart] = value.split('T');
  return { date: date || '', time: (timePart || '').slice(0, 5) };
};

export const combineDatetime = (date, time) => {
  if (!date) return '';
  return `${date}T${time || '00:00'}`;
};
